import { firebaseRemoteConfig } from "../utils/installFirebase.util";

export const INITIAL_STATE = {
  remoteConfig: firebaseRemoteConfig,
  isInitialized: false,
  isRealtimeActive: false,
  lastUpdate: null as Date | null,
  updateTrigger: 0,
};
